import * as React from "react";

let counter = 0;

/** React 17 has no useId: returns an id that stays the same for the component's lifetime. */
export const useStableId = (prefix = "ui", explicitId?: string): string => {
  const [generated] = React.useState(() => {
    counter += 1;
    return `${prefix}-${counter}`;
  });
  return explicitId || generated;
};
